<template>
    <section id="settings-page">

        <DynamicMailStorage v-if="hasSettings" class="separator-line"/>

        <CustomerManagement class="separator-line"/>

        <ConfirmationRequirements class="separator-line"/>

        <EmailNotifications class="separator-line"/>
        <Omniprint class="separator-line"/>
        <PermissionModification class="separator-line"/>

        <PartneredLocations class="separator-line"/>

    </section>
</template>

<script>
// Components
import { mapState } from 'vuex';
import DynamicMailStorage from './settings/DynamicMailStorage';
import CustomerManagement from './settings/CustomerManagement';
import ConfirmationRequirements from './settings/ConfirmationRequirements';
import EmailNotifications from './settings/EmailNotifications';
import PermissionModification from './settings/PermissionModification';
import PartneredLocations from './settings/PartneredLocations';
import Omniprint from './settings/Omniprint';

export default {
    name: 'Settings',
    components: {
        DynamicMailStorage,
        CustomerManagement,
        ConfirmationRequirements,
        EmailNotifications,
        PermissionModification,
        PartneredLocations,
        Omniprint,
    },
    computed: {
        ...mapState( {
            hasSettings: ( state ) => state.Mail.Settings.hasFetchedSettings,
        } ),
    },
    async created() {
        await this.$store.dispatch( 'Mail/Settings/get' );
    },
};
</script>

<style lang="scss" scoped>
#settings-page {
    width: 100%;
    display: flex;
    flex-flow: column nowrap;

    ::v-deep.v-input__control {
        // Don't allow the hitbox for checkboxes to grow all the way to the right across the screen
        flex-grow: unset;
        width: unset;
    }
}

.separator-line {
    border-bottom: 2px solid grey;
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
}
</style>
